import ClientExercises from "../ClientExercises";

interface ExercisesViewProps {
  onBack: () => void;
  initialSearch?: string;
}

const ExercisesView = ({ onBack, initialSearch }: ExercisesViewProps) => {
  return (
    <div className="relative">
      <ClientExercises onBack={onBack} initialSearch={initialSearch} />
    </div>
  );
};

export default ExercisesView;

